import Reveal from "@/components/base/Reveal";

const highlights = [
  { value: "Global", label: "Origem internacional" },
  { value: "Brasil", label: "Atuação nacional" },
  { value: "Portfólio", label: "Diversificado" },
  { value: "Importação", label: "Comercialização" },
];

export default function CompanyHighlights() {
  return (
    <section className="border-y border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-2 gap-y-10 lg:grid-cols-4">
          {highlights.map((item, index) => (
            <Reveal
              key={item.label}
              delay={index * 90}
              className={`px-2 md:px-6 ${
                index !== 0 ? "lg:border-l lg:border-background-300" : ""
              }`}
            >
              <p className="font-heading text-3xl font-medium text-accent-600 md:text-4xl lg:text-5xl">
                {item.value}
              </p>
              <span className="mt-4 block h-px w-10 bg-accent-500/60" />
              <p className="ocean-label mt-3 text-[10px] text-foreground-600 md:text-[11px]">{item.label}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}